export default "__VITE_ASSET__BNUpysI9__"